export default __webpack_public_path__ + "static/media/polarity.2f0884eb.svg";